import { render, staticRenderFns } from "./renchexinxiSG.vue?vue&type=template&id=63a4641a&scoped=true&"
import script from "./renchexinxiSG.vue?vue&type=script&lang=js&"
export * from "./renchexinxiSG.vue?vue&type=script&lang=js&"
import style0 from "./renchexinxiSG.vue?vue&type=style&index=0&id=63a4641a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a4641a",
  null
  
)

export default component.exports